let filters = {
    committee: {name: 'committee', 'nickname': 'Committee', type: 'multi', options: {},selections: {}, size: 2},
    organiser: {name: 'organiser', 'nickname': 'Organiser', type: 'multi', options: {},selections: {}, size: 2},
    meetingdate: {name: 'meetingdate', 'nickname': 'Meeting Date', type: 'date_range', options: {},selections: {}, size: 2},
    month: {name: 'month', 'nickname': 'Meeting Month', type: 'multi', options: {},selections: {}, size: 2},
    status: {name: 'status', 'nickname': 'Status', type: 'multi', options: {},selections: {}, size: 2}
}

module.exports = filters